// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectSection_band__-KleE {
  background: var(--surface-brand-wash);
  border-top: 1px solid var(--surface-selected);
  border-bottom: 1px solid var(--surface-selected);
  padding: var(--space-16) 0;
}

.ProjectSection_carousel__09SKs {
  gap: var(--space-3);
  width: 100%;
}

/* 3:2 keeps the crop off these wide room photos: the source frames are 4:3. */
.ProjectSection_wideMedia__Xqz4Y {
  aspect-ratio: 3 / 2;
  border-radius: var(--radius-lg);
  background: var(--gray-200);
}

.ProjectSection_text__Wismj {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: var(--space-8);
  align-items: start;
}

.ProjectSection_textLead__-Hl7H {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.ProjectSection_title__16Fhd {
  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  text-wrap: balance;
}

.ProjectSection_lead__wBsvj {
  font-size: 1.0625rem;
  line-height: 1.55;
  color: var(--text-primary);
  max-width: 40ch;
}

.ProjectSection_prose__PUPCP {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.ProjectSection_prose__PUPCP p {
  max-width: 62ch;
  line-height: 1.65;
  color: var(--text-secondary);
}

@media (max-width: 900px) {
  .ProjectSection_band__-KleE {
    padding: var(--space-12) 0;
  }

  .ProjectSection_text__Wismj {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-5);
  }

  .ProjectSection_wideMedia__Xqz4Y {
    aspect-ratio: 4 / 3;
  }
}

@media (max-width: 560px) {
  .ProjectSection_band__-KleE {
    padding: var(--space-8) 0;
  }

  .ProjectSection_wideMedia__Xqz4Y {
    aspect-ratio: 16 / 10;
    border-radius: var(--radius-md);
  }

  .ProjectSection_title__16Fhd {
    font-size: 1.25rem;
  }

  .ProjectSection_lead__wBsvj {
    font-size: .9375rem;
  }

  .ProjectSection_prose__PUPCP p {
    font-size: .875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/ProjectSection.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".band {\n  background: var(--surface-brand-wash);\n  border-top: 1px solid var(--surface-selected);\n  border-bottom: 1px solid var(--surface-selected);\n  padding: var(--space-16) 0;\n}\n\n.carousel {\n  gap: var(--space-3);\n  width: 100%;\n}\n\n/* 3:2 keeps the crop off these wide room photos: the source frames are 4:3. */\n.wideMedia {\n  aspect-ratio: 3 / 2;\n  border-radius: var(--radius-lg);\n  background: var(--gray-200);\n}\n\n.text {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n  gap: var(--space-8);\n  align-items: start;\n}\n\n.textLead {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.title {\n  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  text-wrap: balance;\n}\n\n.lead {\n  font-size: 1.0625rem;\n  line-height: 1.55;\n  color: var(--text-primary);\n  max-width: 40ch;\n}\n\n.prose {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.prose p {\n  max-width: 62ch;\n  line-height: 1.65;\n  color: var(--text-secondary);\n}\n\n@media (max-width: 900px) {\n  .band {\n    padding: var(--space-12) 0;\n  }\n\n  .text {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-5);\n  }\n\n  .wideMedia {\n    aspect-ratio: 4 / 3;\n  }\n}\n\n@media (max-width: 560px) {\n  .band {\n    padding: var(--space-8) 0;\n  }\n\n  .wideMedia {\n    aspect-ratio: 16 / 10;\n    border-radius: var(--radius-md);\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .lead {\n    font-size: .9375rem;\n  }\n\n  .prose p {\n    font-size: .875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"band": `ProjectSection_band__-KleE`,
	"carousel": `ProjectSection_carousel__09SKs`,
	"wideMedia": `ProjectSection_wideMedia__Xqz4Y`,
	"text": `ProjectSection_text__Wismj`,
	"textLead": `ProjectSection_textLead__-Hl7H`,
	"title": `ProjectSection_title__16Fhd`,
	"lead": `ProjectSection_lead__wBsvj`,
	"prose": `ProjectSection_prose__PUPCP`
};
export default ___CSS_LOADER_EXPORT___;
